import React from 'react';
import { Field, reduxForm } from 'redux-form';
import { Alert, Form, Button } from 'react-bootstrap';
import { Input, Checkbox, FormActions } from '../../common/components/formControls';
import CentersDropdownList from '../centers/DropdownList';
import { Panel } from 'react-bootstrap';
import validators from '../../common/services/validators';
import { withTranslation } from 'react-i18next';
import ui from '../../common/services/ui';
import BackButton from '../../common/components/BackButton';
import TimeZonePicker from '../timeZones/TimeZonePicker';

const SettingsForm = ({ error, handleSubmit, pristine, submitting, isReadonly, submitSucceeded, titleTypes, referralSourceTypes,
	referralSourceId, onReferralSourceChange, initialValues, notFoundError, showTimetableInUserTimeZone, t }) => {
	let isNew = !initialValues;
	let isOtherReferralSource = referralSourceId == 99;

	return (
		<Form horizontal onSubmit={handleSubmit}>
			{error && <Alert bsStyle='danger'>{error}</Alert>}
			{submitSucceeded && pristine && <Alert bsStyle='success'>{t('Common_UpdateSuccess')}</Alert>}
			{notFoundError && <Alert bsStyle='danger'>{t('Parent_NotFound')}</Alert>}
			<Panel>
				<Panel.Heading>{t('Parent_Profile')}</Panel.Heading>
				<Panel.Body>
					<Field name='titleTypeId' component={Input} componentClass='select' disabled={isReadonly} horizontal label={t('Parent_Title')}>
						<option />
						{ui.makeOptionValues(titleTypes)}
					</Field>
					<Field name='firstName' component={Input} disabled={isReadonly} horizontal required type='text' label={t('Parent_FirstName')} validate={[validators.required]} />
					<Field name='middleName' component={Input} disabled={isReadonly} horizontal type='text' label={t('Parent_MiddleName')} />
					<Field name='lastName' component={Input} disabled={isReadonly} horizontal required type='text' label={t('Parent_LastName')} validate={[validators.required]} />
					<Field name='childRelationship' component={Input} disabled={isReadonly} horizontal type='text' label={t('Parent_ChildRelationship')} />
					<Field name='municipality' component={Input} disabled={isReadonly} horizontal type='text' label={t('Parent_Municipality')} />
					<Field name='city' component={Input} disabled={isReadonly} horizontal required type='text' label={t('Parent_City')} validate={[validators.required]} />
					<Field name='postCode' component={Input} disabled={isReadonly} horizontal type='text' label={t('Parent_PostCode')} />
					<Field name='address' component={Input} disabled={isReadonly} horizontal type='text' label={t('Parent_Address')} />
					<Field name='phoneNumber' component={Input} disabled={isReadonly} horizontal type='text' label={t('Parent_PhoneNumber')} />
					<Field name='alternativePhoneNumber' component={Input} disabled={isReadonly} horizontal type='text' label={t('Parent_AlternativePhoneNumber')} />
					<Field name='facebookAccount' component={Input} disabled={isReadonly} horizontal type='text' label={t('Parent_FacebookAccount')} />
					<Field name='referralSourceId' component={Input} disabled={isReadonly} componentClass='select' horizontal label={t('FO_Parent_HowYouLearn')} onChange={onReferralSourceChange} >
						<option />
						{ui.makeOptionValues(referralSourceTypes)}
					</Field>
					{isOtherReferralSource && <Field name='howYouLearn' component={Input} disabled={isReadonly} horizontal componentClass='textarea' />}
					<CentersDropdownList render='field' name='centerId' disabled={isReadonly} horizontal required label={t('Parent_LastViewedCenter')} validate={validators.required} />
					{showTimetableInUserTimeZone && <TimeZonePicker name='timeZone' disabled={isReadonly} horizontal label={t('Parent_TimeZone')} />}
					<Field name='photoConsent' component={Checkbox} horizontal label={t('Parent_PhotoConsent')} normalize={(v) => { return !!v }} />
					<Field name='marketingEmailConsent' component={Checkbox} horizontal label={t('Parent_MarketingEmailConsent')} normalize={(v) => { return !!v }} />
					<Field name='classReminderConsent' component={Checkbox} horizontal label={t('Parent_ClassReminderConsent')} normalize={(v) => { return !!v }} />
				</Panel.Body>
			</Panel>
			<Panel>
				<Panel.Heading>{t('Parent_Authentication')}</Panel.Heading>
				<Panel.Body>
					<Field name='email' component={Input} disabled={!isNew} horizontal type='text' label={t('Parent_Email')} />
				</Panel.Body>
			</Panel>
			<Panel>
				<Panel.Heading>{t('Parent_Administration')}</Panel.Heading>
				<Panel.Body>
					<Field name='messageToParent' component={Input} disabled={isReadonly} horizontal componentClass='textarea'
						label={t('Parent_MessageToParent')} help={t('Parent_MessageToParent_HelpText')} />
					<Field name='description' component={Input} disabled={isReadonly} horizontal componentClass='textarea' label={t('Parent_Description')} />
					<Field name='isOnline' component={Checkbox} horizontal label={t('Parent_IsOnline')} normalize={(v) => { return !!v }} />
				</Panel.Body>
			</Panel>
			<FormActions horizontal>
				<BackButton>{t('Common_BackToList')}</BackButton>
				<Button type='submit' disabled={isReadonly || pristine || submitting || isReadonly} bsStyle='primary'>{t('Common_Save')}</Button>
			</FormActions>
		</Form>
	);
};

export default reduxForm({ form: 'parent', enableReinitialize: true })(withTranslation()(SettingsForm));

